import React from 'react'
import PropTypes from 'prop-types'

import { Box, Tooltip } from '@mui/material'

import { get } from 'utils/lodash'
import { getInvoiceGenerationStatusParams } from 'components/common/chip/utils'
import { INVOICE_GENERATION_STATUS } from 'settings/constants/billing'
import { getStatusBadge } from '../../billing/BillingCommonMethods'

const RenderGenerationStatusCell = ({ value, row = {} }) => {
  const latestBatchFailure = get(row, 'latestBatchFailure')
  const { label, fullLabel } = getInvoiceGenerationStatusParams(value, latestBatchFailure)

  return (
    <Box>
      {[INVOICE_GENERATION_STATUS.Started, INVOICE_GENERATION_STATUS.Regeneration_Started].includes(value) && getStatusBadge('warning')}
      {[INVOICE_GENERATION_STATUS.Completed, INVOICE_GENERATION_STATUS.Regeneration_Completed].includes(value) && getStatusBadge('success')}
      {[INVOICE_GENERATION_STATUS.Failed, INVOICE_GENERATION_STATUS.Regeneration_Failed].includes(value) && getStatusBadge('error')}
      <Tooltip arrow placement="bottom" title={fullLabel} disableHoverListener={!fullLabel}>
        {label}
      </Tooltip>
    </Box>
  )
}

RenderGenerationStatusCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.object,
}

export default RenderGenerationStatusCell
